import useApi from "@/services/useApi";

const { api } = useApi(); // Add this line

const defaultState = () => {
    return {
        number: "",
        serverId: "", // telegram
        messenger: "",
        qrLink: "",
        anotherNumber: "",
        isPusher: true,
        nextStageActivation: "",
    };
};

const activationModule = {
    namespaced: true,

    state: defaultState(),
    mutations: {
        SET_NUMBER(state, number) {
            state.number = number;
        },
        SET_SERVER_ID(state, serverId) {
            state.serverId = serverId;
        },
        SET_MESSENGER(state, messenger) {
            state.messenger = messenger;
        },
        SET_QR_LINK(state, qrLink) {
            state.qrLink = qrLink;
        },
        CLEAR_QR_LINK(state) {
            state.qrLink = "";
        },
        SET_IS_PUSHER(state, isPusher) {
            if (typeof isPusher === "boolean") {
                state.isPusher = isPusher;
            } else throw new Error("isPusher in VUEX must be boolean");
        },
        SET_ANOTHER_NUMBER(state, number) {
            state.anotherNumber = number;
        },
        SET_NEXT_STAGE_ACTIVATION(state, nextStageActivation) {
            state.nextStageActivation = nextStageActivation;
        },
        CLEAR_STATE(state) {
            Object.assign(state, defaultState());
        },
    },
    actions: {
        async addNumber({ state, commit }) {
            const { headers } = useApi();

            const payload = {
                number: state.number,
                messenger: state.messenger,
            };
            try {
                const response = await api.post("/api/numbers/add", payload, {
                    headers,
                });
                console.debug(response);
                return true;
            } catch (er) {
                switch (er.response?.data?.description) {
                    case "The number already exists":
                        commit(
                            "openDialog",
                            {
                                name: "InformationDialog",
                                params: { info: "existsError" },
                            },
                            { root: true }
                        );
                        break;
                    default:
                        commit(
                            "openDialog",
                            {
                                name: "InformationDialog",
                                params: { info: "error" },
                            },
                            { root: true }
                        );
                        break;
                }
                return false;
            }
        },
    },
};

export default activationModule;
